import Spinner from '@rio-cloud/rio-uikit/Spinner';

export const Loading = () => (
    <div className='height-100vh display-flex justify-content-center align-items-center'>
        <Spinner isDoubleSized />
    </div>
);
